import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./add_state.css";
import { AddStateMobileStep1 } from "./add_state_mobile";
import {API_BASE_URL} from "../config.js";
export default function AddState() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientId, patientName } = location.state || {};

  const [diseaseCode, setDiseaseCode] = useState("");
  const [status, setStatus] = useState("infected");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");

  const [diseases, setDiseases] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchDiseases = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await fetch(`${API_BASE_URL}/diseases/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            ...(token && { "Authorization": `Bearer ${token}` })
          },
        });

        if (response.ok) {
          const data = await response.json();
          setDiseases(data);
        } else {
          console.error("فشل في جلب قائمة الأمراض من الخادم");
        }
      } catch (error) {
        console.error("حدث خطأ أثناء الاتصال بالخادم لجلب الأمراض:", error);
      }
    };

    fetchDiseases();
  }, []);

  const handleNext = () => {
    navigate("/add-state-step2", {
      state: {
        patientId,
        patientName,
        diseaseCode,
        status,
        weight,
        height,
      },
    });
  };
  if (isMobile) {
    return (
        <AddStateMobileStep1 
            patientName={patientName}
            diseaseCode={diseaseCode}
            setDiseaseCode={setDiseaseCode}
            status={status}
            setStatus={setStatus}
            weight={weight}
            setWeight={setWeight}
            height={height}
            setHeight={setHeight}
            diseases={diseases}
            onNext={handleNext}
            onBack={() => navigate(-1)}
        />
    );
}
  return (
    <div className="add-state-container" dir="rtl">
      <img className='syria-logo-add-state-logo' src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="My Image" />
      <div className="add-state-title">إضافة حالة</div>
      <div className="add-state-stepper">
              <div className="add-state as-step-active">1</div>
              <div className="add-state-stepper-line"></div>
              <div className="add-state">2</div>
              <div className="add-state-stepper-line"></div>
              <div className="add-state">3</div>
      </div>
      <div className="add-state-form">
        <label>*اسم المريض</label>
        <input className="add-state-input" placeholder="اختر المريض"  value={patientName || ""} disabled />
          
        <label>*رمز المرض</label>
        <input 
          list="illness" 
          className="add-state-input" 
          placeholder="ادخل رمز المرض" 
          value={diseaseCode} 
          onChange={(e) => setDiseaseCode(e.target.value)}
        />
        
        {/* تم تعديل disease.code إلى disease.disease_code ليتطابق مع الباك يند */}
        <datalist id="illness">
          {diseases.map((disease) => (
            <option 
              key={disease.id || disease.disease_code} 
              value={disease.disease_code}
            >
              {disease.name ? `${disease.disease_code} - ${disease.name}` : disease.disease_code}
            </option>
          ))}
        </datalist>

        <label>*الحالة</label>
            <div className="add-state-state-radio-group">
              <label className="add-state-radio"><input type="radio" name="status" value="cured" checked={status === 'cured'} onChange={(e) => setStatus(e.target.value)}/> تعافي</label>
              <label className="add-state-radio"><input type="radio" name="status" value="infected" checked={status === 'infected'} onChange={(e) => setStatus(e.target.value)} /> مصاب</label>
            </div>
         
        <div className="add-state-grid">
            <div className="add-state-grid-item">
              <label className="add-state-label">الوزن</label>
              <input className="add-state-input" placeholder="كغ" value={weight} onChange={(e) => setWeight(e.target.value)}/>
            </div>

            <div className="add-state-grid-item">
              <label className="add-state-label">الطول</label>
              <input className="add-state-input" placeholder="سم" value={height} onChange={(e) => setHeight(e.target.value)}/>
            </div>

            <div className="add-state-grid-item">
              <label>ضغط الدم</label>
              <input className="add-state-input" placeholder="مثال: 120/80" />
            </div>

            <div className="add-state-grid-item">
              <label>سكر الدم</label>
              <input className="add-state-input" placeholder="ممول/دل" />
            </div>
        </div>

        <div className="add-state-actions">
           <button type="button" className="add-state-btn-primary" onClick={handleNext}> التالي </button>
        </div>

        </div>
    </div>
  );
}